"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyDefaultGuardSetArgs = exports.defaultCandyGuardNames = void 0;
const umi_1 = require("@metaplex-foundation/umi");
/** @internal */
exports.defaultCandyGuardNames = [
    'botTax',
    'solPayment',
    'tokenPayment',
    'startDate',
    'thirdPartySigner',
    'tokenGate',
    'gatekeeper',
    'endDate',
    'allowList',
    'mintLimit',
    'nftPayment',
    'redeemedAmount',
    'addressGate',
    'nftGate',
    'nftBurn',
    'tokenBurn',
    'freezeSolPayment',
    'freezeTokenPayment',
    'programGate',
    'allocation',
    'token2022Payment',
];
/** @internal */
exports.emptyDefaultGuardSetArgs = exports.defaultCandyGuardNames.reduce((acc, name) => {
    acc[name] = (0, umi_1.none)();
    return acc;
}, {});
//# sourceMappingURL=default.js.map